import { useGlobalOpenWallet } from '@/store/commonStore';
import React from 'react'
import { createPortal } from 'react-dom';
import './index.less'
import Wallet from './wallet/wallet';
import { CloseIcon } from '@/componentsUI/Icon';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { getMobileCenteredShellPortalRoot } from '@/layout/components/mobileCenteredShell/portal';
import WalletHelpButton from '@/pages/wallet/WalletHelpButton';

const MobileWallet = () => {

    const { t } = useTranslationPlus('Wallet');
    const [visible, setVisible] = useGlobalOpenWallet();

    const mobileWalletPanel = visible ? (
        <div className='mobile-wallet-parent' role="dialog" aria-modal="true">
            <button
                type="button"
                className="mobile-wallet-mask"
                aria-label="Close wallet"
                onClick={() => setVisible(false)}
            />
            <div className={'mobile-wallet'}>
                <div className='header'>
                    <div className='l'>{t('Wallet')}</div>
                    <WalletHelpButton className="mobile-wallet-help-btn" />
                    <button className={'btn-close'}
                        onClick={() => {
                            setVisible(false)
                        }}
                    >
                        <CloseIcon className={'svg-icon'} />
                    </button>
                </div>
                <div className='content'>
                    <Wallet />
                </div>

            </div>
        </div>
    ) : null;

    return (
        <>
            {mobileWalletPanel &&
                createPortal(
                    mobileWalletPanel,
                    getMobileCenteredShellPortalRoot() || document.body
                )}
        </>

    )
}


export default MobileWallet
